import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectUserToken, selectUserData } from "../../../features/userSlice";
import { dealsPromotionsEndpointLogic } from "../../../logic/Operations/DealsPromotionsEndpointLogic";
import DealsAndPromotionsFilter from "./DealsAndPromotionsFilter";
import DealsAndPromotionsTable from "./DealsAndPromotionsTable";
import CommissionPlansTableSkeleton from "./CommissionPlansTableSkeleton";
import { CheckPermissions } from "../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";

const tableHeadings = {
  brand_name: "Brand Name",
  brand_id: "Brand ID",
  website: "Website",
  status: "Status",
  plan_name: "Plan name",
  plan_term: "Plan Term",
  cpa: "CPA",
  rs: "RS",
  currency: "Currency",
};

const CommissionPlansTab = () => {
  const oauthTokenHeader = useSelector(selectUserToken) as string;
  const userData = useSelector(selectUserData);
  const canEdit = CheckPermissions(
    userData?.data?.products?.partners,
    "affiliate_accounts",
    "edit_commission_plans",
  );
  const dealsPortfolioPlans = useSelector(
    (state: any) => state.dealsPromotions.dealsPortfolioPlans,
  );
  const isLoading = useSelector(
    (state: any) => state.dealsPromotions.isLoadingDealsPortfolioPlans,
  );
  const currencies = useSelector(
    (state: any) => state.dealsPromotions.currencies,
  );

  useEffect(() => {
    if (!dealsPortfolioPlans) {
      dealsPromotionsEndpointLogic.getDealsPortfolioPlans(oauthTokenHeader);
    }
    if (canEdit && !currencies) {
      dealsPromotionsEndpointLogic.getCurrencies(oauthTokenHeader);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oauthTokenHeader]);

  if (isLoading) {
    return (
      <>
        <DealsAndPromotionsFilter />
        <CommissionPlansTableSkeleton tableHeadings={tableHeadings} />
      </>
    );
  }

  return (
    <>
      <DealsAndPromotionsFilter />
      <DealsAndPromotionsTable
        tableHeadings={tableHeadings}
        rows={dealsPortfolioPlans ?? []}
        canEdit={canEdit}
      />
    </>
  );
};

export default CommissionPlansTab;
